import * as React from 'react';
import { classes, style } from 'typestyle';
import { ModalProps } from '../../../modal';
import { rebrand } from '../../../../theme/color';
import { center } from 'csstips';
import { Component, deps, inject, observer } from '../../../../lib/component';
import { ScrollableOverlay } from '../../../scrollable-overlay/scrollable-overlay';
import overlayStyles from '../../../../styles/scrollable-overlay';
import { Button } from '../../atoms/button/Button';
import { ButtonProminence, ButtonSize } from '../../atoms/button/buttonStyles';
import { important } from 'csx';
import { spacing } from '../../../../theme/spacing';

const styles = {
  modal: style(center, {
    maxWidth: '550px',
  }),
  title: style({
    textAlign: 'center',
    fontSize: important('32px'),
  }),
  body: style({
    borderTop: `1px solid ${rebrand.light1.toString()}`,
    paddingTop: spacing.LARGE,
    minHeight: 'fit-content',
  }),
  infoText: style({
    marginTop: 0,
    marginBottom: 0,
    fontSize: '16px',
    $nest: {
      '& + &': {
        marginTop: spacing.LARGE,
      },
    },
  }),
  actions: style({
    marginTop: '24px',
  }),
  actionBtn: style({
    width: '100%',
  }),
};

export type ResubscribeModalProps = ModalProps;

@inject(deps)
@observer
export class ResubscribeModal extends Component<ResubscribeModalProps> {
  render() {
    const {
      show,
      onRequestClose,
      model: {
        user: { channel, currentV2Subscription },
      },
      controller: {
        subscription: { resumeV2PlanSubscription },
      },
    } = this.props;

    const handleConfirm = () => {
      if (!currentV2Subscription) return null;

      resumeV2PlanSubscription(channel.stripe_subscription_id);
      onRequestClose();
    };

    return (
      <ScrollableOverlay className={styles.modal} show={show} onRequestClose={onRequestClose}>
        {currentV2Subscription && (
          <>
            <div className={overlayStyles.header}>
              <h3 className={classes(overlayStyles.title, styles.title)}>
                Re-subscribe to {currentV2Subscription.plan_name}
              </h3>
            </div>

            <div className={styles.body}>
              <p className={styles.infoText}>
                <strong className={style({ fontSize: '20px' })}>
                  Your subscription will resume immediately, it&apos;s that simple!
                </strong>
              </p>
              <p className={styles.infoText}>
                You don&apos;t have to pay anything and your subscription will renew monthly unless you cancel.
              </p>

              <div className={styles.actions}>
                <Button
                  className={styles.actionBtn}
                  prominence={ButtonProminence.PRIMARY}
                  size={ButtonSize.LARGE}
                  onClick={handleConfirm}
                  data-test-resubscribe-modal-confirm
                >
                  Confirm subscription
                </Button>
              </div>
            </div>
          </>
        )}
      </ScrollableOverlay>
    );
  }
}
